import * as R from 'ramda'
import { empty, of } from 'rxjs'
import { delayWhen, filter, switchMap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { LOCATION_CHANGE } from 'connected-react-router'
import { queryFromString } from 'helpers/url'
import { isProductFetched } from 'domain/resources'
import * as Actions from 'store/actions/index.ts'
import { awaitForProductFetched, awaitForSaleFetched } from 'store/epics/helpers/resources'
import googleTags from 'tracking/googleTags'
import {
  getSaleStartTime, getOperationCode, getSaleTitle, getIsSaleFetched,
  getProductSourceKey, getProductCallPrice, getProductTitle
} from 'store/selectors'
import {
  isCatalogOrUniversePageAction, isProductPageAction, isSaleHomePageAction, getPageNameFromAction
} from 'domain/router'
import { DEFAULT_DATA } from '../constants'
import { isSamePage } from '../../helpers/router'

// type GetGGProps = (string, State, Action) => GoogleTagsPropsFn
const getGGProps = (eventType, state, locationChangeAction) => {
  const sendToParam = (eventType === 'landing_unique') ? 'landing+unique' : 'page-vue+standard'
  const defaultGGProps = {
    cat: (eventType === 'landing_unique') ? 'landing' : 'page-vue',
    type: 'voyage',
    'u1': getPageNameFromAction(locationChangeAction),
    'u19': 'vente-privee',
    'u2': getOperationCode(state),
    'u5': getSaleStartTime(state),
    'u6': getSaleTitle(state)
  }

  if (isProductPageAction(locationChangeAction)) {
    return googleActiveToken => ({
      ...DEFAULT_DATA,
      ...defaultGGProps,
      'send_to': `${googleActiveToken}/voyage/${sendToParam}`,
      'u7': getProductTitle(state),
      'u8': getProductSourceKey(state),
      'u9': getProductCallPrice(state)
    })
  }

  return googleActiveToken => ({
    ...DEFAULT_DATA,
    ...defaultGGProps,
    'send_to': `${googleActiveToken}/voyage/${sendToParam}`
  })
}

const landingAndViewedEpic = (actions$, state$) => (
  actions$.pipe(
    ofType(LOCATION_CHANGE),
    filter(R.anyPass([
      isSaleHomePageAction,
      isCatalogOrUniversePageAction,
      isProductPageAction
    ])),
    delayWhen(locationChangeAction => {
      const state = state$.value
      const resourceFetched$ = actions$.pipe(ofType(Actions.resources.RESOURCE_FETCHED))

      if (isProductPageAction(locationChangeAction)) {
        const locationChangeKey = queryFromString(locationChangeAction.payload.location.search).key
        return (getIsSaleFetched(state) && isProductFetched(locationChangeKey)(state$.value))
          ? of({})
          : awaitForProductFetched(locationChangeKey, resourceFetched$, state$)
      }

      return (getIsSaleFetched(state))
        ? of({})
        : awaitForSaleFetched(resourceFetched$, state$)
    }),
    filter(locationChangeAction => {
      if (isProductPageAction(locationChangeAction) && !isSamePage(locationChangeAction, state$.value)) {
        return false
      }

      return true
    }),
    switchMap(locationChangeAction => {
      googleTags.track(getGGProps('landing_unique', state$.value, locationChangeAction))
      googleTags.track(getGGProps('viewed-pages_standard', state$.value, locationChangeAction))
      return empty()
    })
  )
)

export default landingAndViewedEpic
